import { Reveal } from "@/components/Reveal";

export const PARTNER_BADGES = [
  {
    name: "Amazon Ads Verified Partner",
    img: "/amazon-verified-partner.png?v=2",
    href: "https://advertising.amazon.com/partners/directory/details/amzn1.ads1.ma1.43nrsaw1n7hzojqbw13e9mycx/DNA-Digital?sref_=user",
  },
  { name: "Google Partner", img: "/partner-google.png", href: "https://www.google.com/partners/agency?id=6149486763" },
  { name: "Meta Business Partner", img: "/partner-meta.png", href: "https://www.facebook.com/business/partner-directory" },
  { name: "Shopify Partner", img: "/partner-shopify.png", href: "https://www.shopify.com/partners" },
];

export function PartnerBadgeRow({ variant = "section" }) {
  const footer = variant === "footer";
  const h = footer ? "h-10 sm:h-11" : "h-14 sm:h-16";
  return (
    <div className={`flex flex-wrap items-center justify-center ${footer ? "gap-4 sm:gap-6" : "gap-6 sm:gap-10"}`}>
      {PARTNER_BADGES.map((p) => (
        <a
          key={p.name}
          href={p.href}
          target="_blank"
          rel="noreferrer"
          data-testid={`partner-${p.name.split(" ")[0].toLowerCase()}${footer ? "-footer" : ""}`}
          className="inline-block transition-transform duration-300 hover:scale-105"
          title={p.name}
        >
          <img src={p.img} alt={p.name} className={`${h} w-auto rounded-lg`} loading="lazy" />
        </a>
      ))}
    </div>
  );
}

export function Partners() {
  return (
    <section className="border-y border-white/5 bg-surface/20 py-16 lg:py-20" data-testid="partners">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <Reveal>
          <p className="mb-10 text-center font-mono text-xs uppercase tracking-[0.3em] text-muted">
            Official platform partners
          </p>
          <PartnerBadgeRow variant="section" />
        </Reveal>
      </div>
    </section>
  );
}
